/* This component is to render lineChart it expects the data in the format:
const lineChartData = [
  { name: 'Jan 1', electricMeterValue: 400, electricSolarValue: 200 },
  { name: 'Feb 1', electricMeterValue: 300, electricSolarValue: 500 },
];
It will show the lines on the graph only when the data is passed in the above way and also the xAxis dataKey is set to name */

import {
    LineChart,
    ResponsiveContainer,
    Legend,
    Tooltip,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Label
} from 'recharts';
import { lineChartColors } from './chartHelpers';

const getLines = ({ lineChartData, lineChartColors }: any) => {
    const lineCharts: any = [];
    if (lineChartData) {
        Object.entries(lineChartData)
            .filter(([key]) => key !== 'name')
            .forEach(([item]: any, index: any) => {
                lineCharts.push(
                    <Line
                        type='monotone'
                        dataKey={item}
                        key={index}
                        strokeWidth={2}
                        stroke={lineChartColors[index]}
                    />
                );
            });
    }
    return lineCharts;
};

function LineCharts(props: any) {
    const {
        containerHeight,
        lineChartData,
        chartTitle,
        xAxisLabel,
        yAxisLabel,
        yAxisUnit,
        yAxisTickCount,
        lineChartColors
    } = props;
    return (
        <ResponsiveContainer height={containerHeight} width='100%'>
            <LineChart
                data={lineChartData}
                margin={{
                    top: 40,
                    right: 20,
                    left: 10,
                    bottom: 20
                }}
            >
                <text x={'50%'} y={10} fill='black' textAnchor='middle' dominantBaseline='central'>
                    <tspan fontSize='20'>{chartTitle}</tspan>
                </text>
                <CartesianGrid vertical={false} />
                <XAxis
                    allowDuplicatedCategory={false}
                    padding={{ left: 15, right: 10 }}
                    dataKey='name'
                >
                    <Label value={xAxisLabel} position='bottom' offset={0} />
                </XAxis>
                <YAxis
                    axisLine={false}
                    unit={yAxisUnit}
                    tickLine={false}
                    tickCount={yAxisTickCount}
                >
                    <Label
                        value={yAxisLabel}
                        angle={-90}
                        style={{ textAnchor: 'middle' }}
                        position='insideLeft'
                        offset={1}
                    />
                </YAxis>
                <Tooltip isAnimationActive={false} />
                <Legend />
                {getLines({
                    lineChartData: lineChartData?.[0],
                    lineChartColors: lineChartColors
                })}
            </LineChart>
        </ResponsiveContainer>
    );
}

LineCharts.defaultProps = {
    xAxisLabel: '',
    lineChartColors: lineChartColors,
    yAxisUnit: '',
    yAxisTickCount: 5,
    containerHeight: 400,
    chartTitle: ''
};

export default LineCharts;
